import { render, staticRenderFns } from "./IBD.vue?vue&type=template&id=ae84b796&scoped=true&"
import script from "./IBD.vue?vue&type=script&lang=js&"
export * from "./IBD.vue?vue&type=script&lang=js&"
import style0 from "./IBD.vue?vue&type=style&index=0&id=ae84b796&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae84b796",
  null
  
)

export default component.exports